import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Home } from '@/components/pages/Home';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default AppRoutes;
